/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { StreemApiRunImageDetectorRequestToJSON, StreemApiRunImageDetectorResponseFromJSON, } from '../models';
/**
 *
 */
export class ImagesApi extends runtime.BaseAPI {
    /**
     * Run OCR on provided image and return results without persisting them to the database
     * Process Image
     */
    async runImageDetectorRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/image/detections`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiRunImageDetectorRequestToJSON(requestParameters.streemApiRunImageDetectorRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiRunImageDetectorResponseFromJSON(jsonValue));
    }
    /**
     * Run OCR on provided image and return results without persisting them to the database
     * Process Image
     */
    async runImageDetector(streemApiRunImageDetectorRequest) {
        const response = await this.runImageDetectorRaw({ streemApiRunImageDetectorRequest: streemApiRunImageDetectorRequest });
        return await response.value();
    }
}
//# sourceMappingURL=ImagesApi.js.map